import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { initialStatus, Status } from 'projects/angular-clarity/src/app/stores/status.interface';
import * as actions from './actions';
import { SafeLinksPolicy } from './model';

export const featureKey = 'exoSafeLinksPolicy';
export interface State extends EntityState<SafeLinksPolicy>, Status {}

export const adapter: EntityAdapter<SafeLinksPolicy> = createEntityAdapter<SafeLinksPolicy>({
    selectId: (entity) => entity.Identity,
});

export const initialState: State = adapter.getInitialState({
    ...initialStatus,
});

export const reducer = createReducer(
    initialState,
    on(actions.loadSafeLinksPolicySuccess, (state, action) =>
        adapter.setAll(action.data, { ...state, loaded: true, error: null }),
    ),
    on(actions.loadSafeLinksPolicyFailure, (state, { error }) => ({ ...state, error })),

    on(actions.createExoSafeLinksPolicy, (state) => ({ ...state, updating: true, error: null })),
    on(actions.createExoSafeLinksPolicySuccess, (state, action) =>
        adapter.upsertOne(action.data, { ...state, updating: false, error: null }),
    ),
    on(actions.createExoSafeLinksPolicyFailure, (state, { error }) => ({ ...state, updating: false, error })),

    on(actions.updateExoSafeLinksPolicy, (state) => ({ ...state, updating: true, error: null })),
    on(actions.updateExoSafeLinksPolicySuccess, (state, action) =>
        adapter.upsertOne(action.data, { ...state, updating: false, error: null }),
    ),
    on(actions.updateExoSafeLinksPolicyFailure, (state, { error }) => ({ ...state, updating: false, error })),
);

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();
